import { t } from "i18next";
import ImageInput from "../ImageInput";
import { useEffect, useRef, useState } from "react";
import { ReturnCondition } from "../../Api/Models/return.model";
import { TickFilledIcon } from "../Icons/TickFilledIcon";

interface ProductStateProps {
  backButtonOnClick: CallableFunction;
  saveButtonOnClick: CallableFunction;
  initialData?: {
    condition: ReturnCondition | null;
    image: File | null;
    note: string | null;
  };
}

const ProductState: React.FunctionComponent<ProductStateProps> = ({
                                                                    backButtonOnClick,
                                                                    saveButtonOnClick,
                                                                    initialData,
                                                                  }) => {
  const conditionRef = useRef<ReturnCondition>();
  const noteRef = useRef<HTMLTextAreaElement | null>(null);
  const [images, setImages] = useState<File[]>([]);
  const [selectedCondition, setSelectedCondition] = useState<number | null>(null);
  const [conditionError, setConditionError] = useState<boolean>(false);

  // **VISSZATÖLTÉS AZ ELŐZŐ ADATOKKAL**
  useEffect(() => {
    if (initialData) {
      console.log("Loading initial data:", initialData);
      setSelectedCondition(initialData.condition);
      conditionRef.current = initialData.condition ?? undefined;
      setImages(initialData.image ? [initialData.image] : []);
      if (noteRef.current) {
        noteRef.current.value = initialData.note ?? "";
      }
    }
  }, [initialData]);

  const handleSave = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (conditionRef.current == null) {
      setConditionError(true);
      return;
    }
    saveButtonOnClick(
        conditionRef.current,
        images[0] ?? null,
        noteRef.current?.value
    );
  };

  return (
      <form onSubmit={handleSave}>
        {/*}
        <div className="navigationbar navigationbar--dark mb-6">
          <div className="navigationbar__left">
          <span onClick={() => backButtonOnClick()} className="navigationbar__button">
            <LongArrowLeftIcon />
          </span>
          </div>
          <div className="navigationbar__center">
            <div className="navigationbar__title">{t("Item details")}</div>
          </div>
        </div>*/}

        <div className="mb-3">
          <div className="grid gap-3 grid-cols-2">

            {[
              { id: "manufacturing_fault", value: ReturnCondition.MANUFACTURING_FAULT, label: t("Manufacturing faultiness") },
              { id: "overused", value: ReturnCondition.OVERUSED, label: t("Overused") },
              { id: "broken", value: ReturnCondition.BROKEN, label: t("Broken") },
              { id: "stain", value: ReturnCondition.STAIN, label: t("Stain") },
            ].map((option) => (
              <>
              {/*}
                <div
                    key={option.id}
                    className={`product-list-card__option ${selectedCondition === option.value ? "marked" : ""}`}
                    onClick={() => {
                      conditionRef.current = option.value;
                      setSelectedCondition(option.value);
                    }}
                >
                  <input type="radio" id={option.id} name="condition" className="hidden" value={option.value} />
                  <label htmlFor={option.id} className="w-full">{option.label}</label>
                  {selectedCondition === option.value && <CheckIcon />}
                </div>
*/}

                <label
                    key={option.id}
                    className="choice-card"
                    onClick={() => {
                      conditionRef.current = option.value;
                      setSelectedCondition(option.value);
                      setConditionError(false);
                    }}
                >
                  <input
                  type="radio"
                  id={option.id} 
                  name="condition" 
                  className="hidden" 
                  value={option.value} 
                  checked={selectedCondition === option.value} 
                  />
                  <div className="choice-card__content">
                    {option.label}
                    <div className="choice-card__marker">
                      <TickFilledIcon/>
                    </div>
                  </div>
                </label>
              </>
            ))}
          </div>
          {conditionError && (
              <div className="text-red-500 text-sm mt-2">
                {t("Please select a condition!")}
              </div>
          )}
        </div>

      <div className="separator-line mb-3"></div>

      <div className="text-secondary mb-2">{t('Description')}</div>
      <textarea
        className="mb-3 input-field"
        placeholder="Please write your note here!"
        ref={noteRef}
      ></textarea>

      <div className="separator-line mb-3"></div>

      <div className="mb-6">
        <ImageInput images={images} setImages={setImages} required={true} />
      </div>

      <div className="flex justify-between">
        {/*<button className="button" onClick={() => backButtonOnClick()}>
          <i className="icon-arrow-left button__icon button__icon--prefix"></i>
          {t("Back")}
        </button>*/}
        <button type="submit" className="button">
          {t("Save")}
        </button>
      </div>
    </form>
  );
};

export default ProductState;
